import Logo from '@/components/Logo';

const Header = () => {
    return (
        <header className={"heroHeader"}>
            <div className="left-flex">
                <Logo/>
            </div>
            <div className="right-flex">
            </div>
        </header>
    );
}

export default Header;